import { FilterValueType, Facet, FacetContent, instanceOfInputValue, instanceOfRangeValue } from 'festo-react-ui-kit';
import React from 'react';
import cn from 'classnames';

import InfoButtonContent from './InfoButtonContent';

import { useAppSelector } from '../../../app/hooks';
import useTranslation from '../../../features/translation/hooks/useTranslation';
import { Filter } from '../../../features/filter/interfaces';
import { getDisabledFilter, getFacetValue } from './utils';

interface FacetWrapperProps {
  onFilterChange: (filterName: string, value: string | number, id: number, childFilterId?: number) => void;
  visible: boolean;
  id: number;
  root?: boolean;
  filter: Filter;
  labelAsTitle?: boolean;
}

const FacetWrapper: React.FC<FacetWrapperProps> = ({ onFilterChange, visible, root, filter, id, labelAsTitle }) => {
  const { type, value, icon, hidden, key, label, unit } = filter;
  const { index: findex } = filter.configuration || {};
  const t = useTranslation();
  const { language } = useAppSelector((state) => state.base);
  const filterValues = useAppSelector((state) => state.filter.filtersValue);
  const disabledFilter = getDisabledFilter({ values: filterValues });

  return (
    <Facet
      className={cn(
        'ems-facet',
        `ems-facet-${key}`,
        `facet--${type}`,
        { hidden: hidden },
        { 'ems-facet--no-index': type === 'mixbox' && !findex },
      )}
      showInfoIcon={icon.visible && (icon.messageTranslationKey !== undefined || icon.imageSrc !== undefined)}
      popupContent={
        icon.visible &&
        icon.messageTranslationKey && <InfoButtonContent amountOfMessages={t(icon.messageTranslationKey)} />
      }
      title={labelAsTitle ? t(label ?? '') : ''}
      open
      visible={visible}
      disabled={disabledFilter === key}
      labelAsTitle
    >
      {value && (
        <FacetContent
          value={getFacetValue(value)}
          unit={t(unit ?? '')}
          id={id.toString() + label}
          type={type}
          onChange={(filterName, newValue): void => {
            onFilterChange(key, filterName as string, id);
          }}
          locale={language}
          index={findex}
          disabled={disabledFilter === key}
          className={cn({ 'ems-facet-content--root': root })}
        />
      )}
    </Facet>
  );
};

export default FacetWrapper;
